import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "television-addon-card__title",
  "data-eq-part": "television-addon-card__title"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "television-addon-card__benefits",
  "data-eq-part": "television-addon-card__benefits"
}
const _hoisted_4 = {
  class: "television-addon-card__price",
  "data-eq-part": "television-addon-card__price"
}

import List from '@/components/List.vue';
import { formatNumber } from '@/helpers';
import TelevisionPackageInterface from '@/interfaces/TelevisionPackageInterface';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TelevisionAddonCard',
  props: {
    addon: {},
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const flagUrl = computed(() => `${window.ioappConfig.themeUri}/public/img/flags/${props.addon.id}.svg`);

const monthlyBasePrice = computed(() => formatNumber(props.addon.price?.recurring.find((recurringPrice) => recurringPrice?.type === 'base_price')?.value || 0, 2));

const addonProConList = computed(() => [
  ...(props.addon.benefits || []),
  ...((props.addon.cons || []).map((con: string | string[]) => [
    Array.isArray(con) ? con[0] : con,
    Array.isArray(con) ? con[1] : undefined,
    'fa-solid fa-xmark',
  ])),
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["television-addon-card io-eq-el", {
        small: _ctx.small,
      }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("img", { src: flagUrl.value }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.addon.name), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(List, {
        type: "icon",
        icon: "fa-solid fa-check",
        items: addonProConList.value,
        small: _ctx.small
      }, null, 8, ["items", "small"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, "+" + _toDisplayString(monthlyBasePrice.value) + " €/Monat", 1)
    ])
  ], 2))
}
}

})